import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import TextInput from "@shared/v2/TextInput";
import Dropdown from "@shared/v2/Dropdown";
import Button from "@shared/v2/Button";
import ExpenseInput from "../ExpenseInput";
import { useExpenseList } from "./customHook";
import { expenseInputHandlr, incomeExpenseInputTxtHandlr } from "./handlers";
import { IncomeExpenseRadio } from "./fractals";

const IncomeExpenseForm = ({ modalThis, setIsOpenNewIncomeModal, addIncome, expList, expenseType }) => {
  const { expenseList } = useExpenseList(expList);
  const invertedExpList = useMemo(() => _.invert(expList));
  const [expenseValue, setExpenseValue] = useState("");

  return (
    <>
      {addIncome && <IncomeExpenseRadio modalThis={modalThis} setExpenseValue={setExpenseValue} />}
      <div>
        {modalThis.state.type === "expense" &&
        invertedExpList[expenseValue.value] !== "Custom" &&
        invertedExpList[expenseValue.value] !== "Custom Income" &&
        invertedExpList[expenseValue.value] !== "Custom Expense" ? (
          <Dropdown
            label="Name"
            menuShouldComeToFront
            name="dropdown-expense"
            value={expenseValue || null}
            onChange={(opt) =>
              expenseInputHandlr(opt, modalThis, setExpenseValue, expenseType, invertedExpList)
            }
            options={expenseList}
            isSearchable={false}
            isClearable={false}
            placeholder={
              expenseType === "company" ? "Select an expense/income" : "Select new expense category"
            }
          />
        ) : (
          <TextInput
            label="Name"
            value={modalThis.state.name}
            onChange={(e) => {
              incomeExpenseInputTxtHandlr(e, modalThis, expenseValue, expenseType, invertedExpList);
            }}
          />
        )}
      </div>

      <div className="tw-max-w-[200px]" data-cy="financials-form-control-wrapper-0">
        <ExpenseInput
          label=""
          value={modalThis.state.value}
          amount={modalThis.state.value}
          isPercentage={!!modalThis.state.percentage}
          name="percentage"
          onValueUpdate={(e) => {
            if (modalThis.state.percentage) {
              modalThis.setState({ value: e.target.value });
            } else {
              modalThis.setState({ value: e.target.value });
            }
          }}
          onRadioUpdate={(e) => {
            modalThis.setState({ percentage: e.target.value === "true" });
          }}
        />
      </div>
      <div className="tw-flex tw-justify-between tw-gap-[16px]">
        <Button size="medium" schema="tertiary" onClick={() => setIsOpenNewIncomeModal(false)}>
          Cancel
        </Button>
        <Button size="medium" schema="primary" onClick={() => modalThis.saveExpenseData()}>
          Save
        </Button>
      </div>
    </>
  );
};

IncomeExpenseForm.propTypes = {
  modalThis: PropTypes.shape().isRequired,
  setIsOpenNewIncomeModal: PropTypes.func.isRequired,
  addIncome: PropTypes.bool,
  expList: PropTypes.shape().isRequired,
  expenseType: PropTypes.string.isRequired,
};

IncomeExpenseForm.defaultProps = {
  addIncome: false,
};

export default IncomeExpenseForm;
export { IncomeExpenseForm };
